import publicApi from './publicApi';
import api from './api';
import { apiPath } from '../config/apiBase';

export const getPublicKafalaStats = async () => {
  const response = await publicApi.get('/public/kafala/stats');
  return response.data;
};

export const getPublicKafalaOrphelins = async () => {
  const response = await publicApi.get('/public/kafala/orphelins');
  return response.data;
};

export const getPublicKafalaOrphelin = async (id) => {
  const response = await publicApi.get(`/public/kafala/orphelins/${id}`);
  return response.data;
};

export const kafalaOrphelinPhotoUrl = (id) => apiPath(`/public/kafala/orphelins/${id}/photo`);

export const submitKafalaDemande = async (payload) => {
  const response = await publicApi.post('/public/kafala/demandes', payload);
  return response.data;
};

export const submitSaqyaDemande = async (payload) => {
  const response = await publicApi.post('/public/saqya/demandes', payload);
  return response.data;
};

export const submitVolunteerDemande = async (payload) => {
  const response = await publicApi.post('/public/volunteer/demandes', payload);
  return response.data;
};

export const submitOmraDemande = async (payload) => {
  const response = await publicApi.post('/public/omra/demandes', payload);
  return response.data;
};

export const getAdminKafalaDemandes = async (params = {}) => {
  const response = await api.get('/admin/kafala-demandes', { params });
  return response.data;
};

export const updateAdminKafalaDemande = async (id, payload) => {
  const response = await api.patch(`/admin/kafala-demandes/${id}`, payload);
  return response.data;
};

export const deleteAdminKafalaDemande = async (id) => {
  const response = await api.delete(`/admin/kafala-demandes/${id}`);
  return response.data;
};
